import { Phone, MapPin } from "lucide-react";
import { PHONE_TEL, DIRECTIONS_URL } from "../../lib/site";

export const MobileBar = () => (
  <div className="fixed bottom-0 inset-x-0 z-50 lg:hidden grid grid-cols-[2fr_1fr] border-t-2 border-zinc-950" data-testid="mobile-conversion-bar">
    <a
      href={PHONE_TEL}
      className="flex items-center justify-center gap-2 bg-red-700 text-white py-4 font-heading text-sm tracking-wider active:bg-red-800"
      data-testid="mobile-bar-call"
    >
      <Phone className="h-4 w-4" />
      CALL FOR TODAY'S PRICE
    </a>
    <a
      href={DIRECTIONS_URL}
      target="_blank"
      rel="noopener noreferrer"
      className="flex items-center justify-center gap-2 bg-zinc-950 text-white py-4 font-heading text-sm tracking-wider active:bg-zinc-800"
      data-testid="mobile-bar-directions"
    >
      <MapPin className="h-4 w-4" />
      DIRECTIONS
    </a>
  </div>
);
